import { Component, CUSTOM_ELEMENTS_SCHEMA, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-settings-application-settings-section',
    standalone: true,
    templateUrl: './settings-application-settings-section.component.html',
    imports: [TranslatePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SettingsApplicationSettingsSectionComponent {
    public showEnvironmentHint = input.required<boolean>();
    public environmentHintChange = output<void>();
}
